import { CTALinkButtonType } from '../types';
import { buttonVariants } from './Button';
import NoPrefetchLink from './NoPrefetchLink';

interface CTALinkButtonProps {
  value: CTALinkButtonType;
}

function CTALinkButton({ value }: CTALinkButtonProps) {
  const { link, isCentered, isIncreasedSpacing } = value;
  const spacing = isIncreasedSpacing ? 'my-16' : 'my-6';

  return (
    <div
      className={`flex max-w-[75ch]  flex-col items-center ${isCentered && 'justify-center'} ${spacing} sm:flex-row md:20`}
    >
      {link?.linkText && (
        <NoPrefetchLink className={buttonVariants({ variant: 'primary' })} href={link.href || '/'}>
          {link.linkText}
        </NoPrefetchLink>
      )}
    </div>
  );
}

export default CTALinkButton;
